import { addErrorBreadcrumb, parseErrorTrackingEnv } from '@/lib/errorTracking';

export type WsSurface = 'control' | 'queue';

export type WsBreadcrumbEvent = {
  event: 'connect' | 'open' | 'auth_send' | 'auth_ok' | 'message_in' | 'message_out' | 'parse_failed' | 'close' | 'error' | 'reconnect_scheduled';
  surface: WsSurface;
  ws_type?: string;
  handler?: string;
  session_id?: string;
  robot_id?: string | null;
  close_code?: number;
  close_reason?: string;
  direction?: 'in' | 'out';
};

const config = parseErrorTrackingEnv();

const isHighFrequency = (entry: WsBreadcrumbEvent): boolean =>
  entry.ws_type === 'gamepad' || entry.ws_type === 'teleop_status';

const shouldSample = (entry: WsBreadcrumbEvent): boolean => {
  if (entry.event === 'error' || entry.event === 'parse_failed') {
    return true;
  }
  if (!isHighFrequency(entry)) {
    return true;
  }
  return Math.random() <= config.wsHighFreqSampleRate;
};

export const addWsBreadcrumb = (entry: WsBreadcrumbEvent): void => {
  if (!shouldSample(entry)) {
    return;
  }
  addErrorBreadcrumb(`ws.${entry.surface}.${entry.event}`, {
    ws_handler: entry.handler,
    ws_type: entry.ws_type,
    session_id: entry.session_id,
    robot_id: entry.robot_id,
    close_code: entry.close_code,
    close_reason: entry.close_reason,
    direction: entry.direction,
    sample_rate: isHighFrequency(entry) ? config.wsHighFreqSampleRate : 1,
  });
};
